/**
 * App
 * Root application component. Mounts the router (all page routes) inside the
 * top-level layout wrapper. Keep this component thin: page-level concerns
 * belong in `src/main-component/*` and shared UI in `src/components/*`.
 */
import React from 'react';
import AllRoute from '../router';
import './App.css';

const App = () => {
  return (
    <div className="App" id="scrool">
      <AllRoute />
    </div>
  );
};

export default App;
